import axios from 'axios';

export interface ICreateDocumentParsingResponse {
  documentId: string;
  uploadUrl: string;
  inputKey: string;
  expiresIn: number;
}

let baseUrl = '';
let getToken: (() => string | null | undefined) | null = null;

export default class DocumentParsingService {
  static configure(url: string, options?: { getToken?: () => string | null | undefined }): void {
    baseUrl = url;
    if (options?.getToken) {
      getToken = options.getToken;
    }
  }

  private static authConfig(extra: any = {}): any {
    const token = getToken?.();
    if (!token) {
      return extra;
    }
    return {
      ...extra,
      headers: { ...(extra.headers || {}), Authorization: `Bearer ${token}` },
    };
  }

  static async createDocument(body: {
    name: string;
    contentType: string;
  }): Promise<ICreateDocumentParsingResponse> {
    const { data } = await axios.post(
      `${baseUrl}api/v2/document-parsing/documents`,
      body,
      this.authConfig(),
    );

    return data;
  }

  // Presigned PUT — Content-Type must exactly match what was sent at createDocument,
  // otherwise S3 returns 403 (signature mismatch).
  static async uploadFile(
    uploadUrl: string,
    file: File,
    onProgress?: (pct: number) => void,
  ): Promise<void> {
    await axios.put(uploadUrl, file, {
      headers: { 'Content-Type': file.type },
      sendAuth0Headers: false,
      onUploadProgress: (e: any) =>
        onProgress?.(Math.round((e.loaded / (e.total ?? 1)) * 100)),
    } as any);
  }
}
